/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

import { Grid } from '../Grid';
import AppNavDownloadButton from './appNavBits/AppNavDownloadButton';
import AppNavShareButton from './appNavBits/AppNavShareButton';
import { AppNavDoneButton } from './appNavBits/AppNavButtons';
import UI_CONSTANTS from '../../../constants/uiConstants';

const AppNavFile = props => (
  <div className={props.isDisable ? 'cmp-nav-file disable' : ''} style={{ paddingTop: UI_CONSTANTS.appTopPadding }}>
    <div className="util-application-frame-forcards-padding">
      <Grid justifyContent="space-between" alignItems="center">
        <div style={{ display: 'flex' }}>
          {props.shareFile ? (
            <AppNavShareButton
              onClick={() => {
                props.shareFile(props.fileDownloadUrl);
              }}
            />
          ) : (
            <div />
          )}
          {props.downloadFile ? (
            <AppNavDownloadButton
              styles={{ marginLeft: 0 }}
              onClick={() => {
                props.downloadFile(props.fileDownloadUrl);
              }}
            />
          ) : (
            <div />
          )}
        </div>
        <AppNavDoneButton onClick={props.doneWithFile} />
      </Grid>
    </div>
  </div>
);

AppNavFile.propTypes = {
  downloadFile: PropTypes.func,
  doneWithFile: PropTypes.func,
  fileDownloadUrl: PropTypes.string,
  isDisable: PropTypes.bool,
  shareFile: PropTypes.func,
};

export default AppNavFile;
